/* biome-ignore-all lint/style/noUnusedTemplateLiteral: cleaner inline spacing with template literals */
'use client';

import { Link } from '@/app_components/common/Link';

export const LegalDisclaimer = () => {
  return (
    <p className='text-xs text-center text-secondary pb-4'>
      {`By creating an account or signing in using the methods below, you agree to Fortune's `}
      <Link
        as='a'
        className='underline'
        href='https://fortune.com/terms-of-use/'
        recipe='content'
        target='_blank'
        variant='primary'
      >
        Terms of Use
      </Link>
      {` and `}
      <Link
        as='a'
        className='underline'
        href='https://fortune.com/privacy-policy/'
        recipe='content'
        target='_blank'
        variant='primary'
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
};
